import React from "react";
import PropTypes from "prop-types";

import Portal from "../Portal/Portal";

import "./ModalWindow.sass";

function ModalWindow({
  title,
  titleClass,
  windowClass,
  isOpen,
  onCancel,
  withClose,
  children,
}) {
  return (
    <>
      {isOpen && (
        <Portal>
          <div className="modalOverlay">
            <div className={`modalWindow ${windowClass}`}>
              {withClose && (
                <span
                  onClick={onCancel}
                  className="modalClose"
                  aria-hidden="true"
                  aria-label="Close confirm"
                />
              )}
              <div className="modalContainer">
                <div className="modalHeader">
                  <div className={`modalTitle ${titleClass}`}>{title}</div>
                </div>
                <div className="modalBody">{children}</div>
              </div>
            </div>
          </div>
        </Portal>
      )}
    </>
  );
}

ModalWindow.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  titleClass: PropTypes.string,
  windowClass: PropTypes.string,
  isOpen: PropTypes.bool,
  onCancel: PropTypes.func,
  withClose: PropTypes.bool,
  children: PropTypes.node,
};

ModalWindow.defaultProps = {
  title: "Modal Window",
  titleClass: "",
  windowClass: "",
  isOpen: false,
  onCancel: () => {},
  withClose: true,
  children: null,
};

export default ModalWindow;
